var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 183,
    height: 105.758,
    viewBox: "0 0 183 105.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3",
    "data-name": "Ret\\xE2ngulo 3",
    width: 47.917,
    height: 79.757,
    fill: "#f591a8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9",
    transform: "translate(-295.492 -386.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5",
    transform: "translate(277.492 394.819)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "CPG",
    transform: "translate(70 64.16)",
    fill: "#1a1a1a",
    fontSize: 60,
    fontFamily: "NotoSans-Bold, Noto Sans",
    fontWeight: 700,
    letterSpacing: "0.09em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CPG")), /*#__PURE__*/React.createElement("text", {
    id: "EMPRESAS",
    transform: "translate(89 92.16)",
    fill: "#1a1a1a",
    fontSize: 16,
    fontFamily: "NotoSans-Bold, Noto Sans",
    fontWeight: 700,
    letterSpacing: "0.09em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EMPRESAS"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(295.492 386.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M15.468,76.784l.011.02-1.29-.688C10.233,74.014,3.247,69.132.83,60.148A27.158,27.158,0,0,1,.913,46.607C2.6,39.677,6.006,35.7,9.636,31.508c3.1-3.586,6.3-7.313,8.369-13.107A35.207,35.207,0,0,0,19.523,1.539L19.306,0l.928,1.152a35.662,35.662,0,0,1,5.9,10.817,37.8,37.8,0,0,1,1.848,14.147,35.006,35.006,0,0,1-4.2,15.428A28.169,28.169,0,0,1,20.513,46.2a45.138,45.138,0,0,0-4.937,7.135c-2.816,4.925-3.208,6.992-3.359,7.768-.083.441-.157.87-.209,1.3a21.149,21.149,0,0,0,.862,8.651,21.926,21.926,0,0,0,1.849,4.405l.328.556Z",
    transform: "translate(0)",
    fill: "#fd1c50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M59.419,78.045c-.682,6.166-4.621,10.183-6.445,12.044a21.13,21.13,0,0,1-6.224,4.6,20.33,20.33,0,0,1-10.136,1.956c-.5-.041-.98-.092-1.418-.167a17.425,17.425,0,0,1-2.627-.447,19.063,19.063,0,0,1-5.46-2.291,10.458,10.458,0,0,0,6.042,1,5.6,5.6,0,0,0,2.33-.759c2.169-1.356,2.69-4.238,2.763-4.693.654-4-2.316-7.106-2.724-7.513q-2.272,1.014-4.562,2.03,1.768-7.856,3.562-15.732,7.358,3.494,14.718,7c-.656.387-1.322.775-1.988,1.154-.4.233-.786.465-1.183.7a14.79,14.79,0,0,1-1.294,18.311,17,17,0,0,0,4.379-4.547c.721-1.1,3.922-6.257,2.543-12.159a20.9,20.9,0,0,0-3.6-7.167c-1.508-2.135-2.626-3.495-2.626-3.495a21.393,21.393,0,0,1-5.452-18.852,20.026,20.026,0,0,1,3.815-8.114l1.017-1.339-.132,1.68a22.823,22.823,0,0,0,1.964,12.012,26.35,26.35,0,0,0,5.514,7.228c2.417,2.436,4.908,4.966,6.351,9.515a19.662,19.662,0,0,1,.875,8.058",
    transform: "translate(-11.607 -16.934)",
    fill: "#fd1c50"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d53f85b2095947b6dd266d25837d3fff.svg";
export { ForwardRef as ReactComponent };